import SelectGroupEmpty from "./SelectGroupEmpty.jsx"
import SelectGroupPrompt from "./SelectGroupPrompt.jsx"

const SelectGroupByGroupsContent = (groups) => {
  if (groups.length === 0) {
    return <SelectGroupEmpty />
  } else {
    return <SelectGroupPrompt />
  }
}

export default function SelectGroup({groups}) {
  return (
    <>
    {SelectGroupByGroupsContent(groups)}
    </>
  )
}
